import {
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { Button, Drawer } from "antd";
import axios from "axios";
import moment from "moment";
import PropTypes from "prop-types";
import React, { ReactElement, useCallback, useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { getParamValue } from "../../../utils";
import { authenticateToken } from "../../../utils/auth";
import { responseNotification } from "../../../utils/notify";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router";
import _ from "lodash";
import MerchantLayout from "../Layout";
import AddMerchant from "../AddMerchant";

import MerchantHeader from "../Layout/topHeader";
import { useDispatch } from "react-redux";
import { SET_MERCHANT_INFO } from "../../../redux/auth/authType";

const MerchantDetails = (): ReactElement => {
  const [singleMerchanrInfo, setSingleMerchantInfo] = useState({
    loading: false,
    data: null,
  });
  const [selectedMerchantForEdit, setSelectedMerchantForEdit] =
    useState(undefined);
  const [visible, setVisible] = useState(false);
  const route = useParams();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const dispatch = useDispatch();

  const fetchMerchantDetails = useCallback((getMerchantId) => {
    if (getMerchantId) {
      try {
        setSingleMerchantInfo({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_CATALOG_READER_API}/merchant/details?merchantId=${getMerchantId}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setSingleMerchantInfo({
                loading: false,
                data: data?.data?.merchant,
              });
              dispatch({
                type: SET_MERCHANT_INFO,
                payload: {
                  merchantInfo: {
                    id: data?.data?.merchant?.id,
                    name: data?.data?.merchant?.name,
                    image: data?.data?.merchant?.image,
                    phone: data?.data?.merchant?.mobileNumber,
                    email: data?.data?.merchant?.email,
                    deleted: data?.data?.merchant?.deleted,
                  },
                },
              });
            } else {
              setSingleMerchantInfo({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setSingleMerchantInfo({ loading: false, data: null });

            console.log(err);
          });
      } catch (error) {
        setSingleMerchantInfo({ loading: false, data: null });

        console.log(error, "error");
      }
    }
  }, []);

  useEffect(() => {
    fetchMerchantDetails((route as any)?.merchantId);
  }, [fetchMerchantDetails, (route as any)?.merchantId]);

  useEffect(() => {
    if (visible) {
      setSelectedMerchantForEdit(undefined);
    }
  }, [selectedMerchantForEdit]);

  useEffect(() => {
    setSelectedMerchantForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setSelectedMerchantForEdit(null);
    fetchMerchantDetails((route as any)?.merchantId);
  };

  const merchant = singleMerchanrInfo?.data;

  return (
    <React.Fragment>
      <MerchantLayout merchantId={(route as any)?.merchantId as string}>
        <div className="bg-white">
          <MerchantHeader
            leftarea={"Merchant Details"}
            rightarea={
              <Button
                type="primary"
                onClick={() =>
                  setSelectedMerchantForEdit(singleMerchanrInfo.data)
                }
                danger
              >
                <EditOutlined /> Edit
              </Button>
            }
          />
          <div className="details-area">
            <div className="pt-4">
              <div className="inner-body">
                <div className="single">
                  <span className="info-name">Merchant Name</span>
                  <span className="info-desc">{merchant?.name}</span>
                </div>

                <div className="single">
                  <span className="info-name">ID</span>
                  <span className="info-desc">{merchant?.id}</span>
                </div>

                <div className="single">
                  <span className="info-name">Phone Number</span>
                  <span className="info-desc">{merchant?.mobileNumber}</span>
                </div>

                <div className="single">
                  <span className="info-name">Email Address</span>
                  <span className="info-desc">{merchant?.email}</span>
                </div>

                <div className="single">
                  <span className="info-name">Status</span>
                  <div className="info-desc">
                    <span
                      className={`radius-btn text-uppercase ${
                        merchant?.deleted === true ? "inacive" : "active"
                      }-btn`}
                    >
                      {merchant?.deleted === true ? (
                        <>
                          <CloseOutlined className="mr-1" /> Deleted
                        </>
                      ) : (
                        <>
                          <CheckOutlined className="mr-1" /> Active{" "}
                        </>
                      )}
                      {merchant?.status?.split("_").join(" ")}
                    </span>
                  </div>
                </div>

                <div className="single">
                  <span className="info-name">Created Date</span>
                  <span className="info-desc">
                    {moment(merchant?.createdAt).format("lll")}
                  </span>
                </div>

                {visible ? (
                  <QuestionCircleOutlined
                    onClick={() => {
                      setVisible(false);
                    }}
                  />
                ) : (
                  <QuestionCircleOutlined
                    onClick={() => {
                      setVisible(true);
                    }}
                  />
                )}

                {visible && (
                  <div className="">
                    <h6 className="mt-5 title" style={{ width: "98%" }}>
                      Activity Logs
                    </h6>
                    <div className="inner-body">
                      <div className="single">
                        <span className="info-name">Created Date</span>
                        <span className="info-desc">
                          {moment(merchant?.createdAt).format("lll")}
                        </span>
                      </div>

                      {merchant?.createdBy?.name ? (
                        <div className="single">
                          <span className="info-name">Created By</span>
                          <span className="info-desc">
                            {merchant?.createdBy?.name}
                          </span>
                        </div>
                      ) : undefined}

                      <div className="single">
                        <span className="info-name">Contact</span>
                        <span className="info-desc">
                          {merchant?.createdBy?.mobileNumber ||
                            merchant?.createdBy?.email}
                        </span>
                      </div>
                    </div>
                    {merchant?.updatedAt ? (
                      <div className="inner-body mt-4">
                        <div className="single">
                          <span className="info-name">Updated Date</span>
                          <span className="info-desc">
                            {moment(merchant?.updatedAt).format("lll")}
                          </span>
                        </div>

                        {merchant?.updatedBy?.name ? (
                          <div className="single">
                            <span className="info-name">Updated By</span>
                            <span className="info-desc">
                              {merchant?.updatedBy?.name}
                            </span>
                          </div>
                        ) : undefined}

                        {merchant?.updatedBy?.mobileNumber ? (
                          <div className="single">
                            <span className="info-name">Contact</span>
                            <span className="info-desc">
                              {merchant?.updatedBy?.mobileNumber ||
                                merchant?.updatedBy?.email}
                            </span>
                          </div>
                        ) : undefined}
                      </div>
                    ) : undefined}
                  </div>
                )}
              </div>
            </div>
          </div>

          <Drawer
            title={selectedMerchantForEdit ? "Edit merchant" : ""}
            width={600}
            onClose={() => {
              setSelectedMerchantForEdit(null);
            }}
            visible={selectedMerchantForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            {selectedMerchantForEdit ? (
              <AddMerchant
                visibleData={selectedMerchantForEdit}
                onCloseMethod={onClose}
              />
            ) : undefined}
          </Drawer>
        </div>
      </MerchantLayout>
    </React.Fragment>
  );
};
MerchantDetails.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default MerchantDetails;
